export default __webpack_public_path__ + "static/via-metamask-cf02b0b211e86b3d886f9cc3283ad296.png";